import styles from "./TextSkeleton.module.scss"

import type { PropsWithChildren } from "react"

export const TextSkeleton = (props: PropsWithChildren) => (
  <span className={styles.textSkeleton}>{props.children}</span>
)
